import { StoreAction } from "../../../types/store"
import { Program } from "../../programs/lib/program";
import { SET_PROGRAMS, SetProgramsAction } from "../../programs/store/actions";

export interface StoreState {
  programs: Program[]
}

export const initialState: StoreState = {
  programs: [],
}

export default function reducer(state: StoreState, action: StoreAction): StoreState {
  switch (action.type) {
    case SET_PROGRAMS: {
      const { programs } = action as SetProgramsAction
      return {
        ...state,
        programs,
      }
    }

    default:
      return state
  }
}
